export const BookmarkTypeValues = [
    'READING',
    'WEBSITE',
    'PODCAST',
    'VIDEO',
    'OTHER'
];
//# sourceMappingURL=bookmark-type.js.map